module.exports = __webpack_public_path__ + "js/components/images/dark_fb-a0624513c34d7f85d312e986434d051d.svg";


//////////////////
// WEBPACK FOOTER
// ./js/components/images/dark_fb.svg
// module id = 822
// module chunks = 31